import angular from 'angular';

angular.module('AaApp.Opp')
    .constant('userProfileRoles', {
        Sales_Associate: 'Sales Associate',
        Base_Sales_Associate: 'Base Sales Associate',
    })
